import { useCallback } from 'react';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import downloadFileByUrl from '@/utils/handlers/downloadFileByUrl';

const getFilesByDocumentId = (documentId?: string) =>
  api.get(API_URL.DOCUMENTS_FILES_BY_DOCUMENT_ID(documentId || ''));

const useDownloadFileById = () => {
  const handleDownload = useCallback(async (fileId: string, customFieldUrl?: string, fileName?: string) => {
    let fileUrl: string = '';
    if (customFieldUrl) {
      fileUrl = customFieldUrl;
    } else {
      const response = await getFilesByDocumentId(fileId);
      fileUrl = response?.data?.files?.[0]?.s3_url || '';
    }
    if (fileUrl) {
      const fileResponse = await fetch(fileUrl);
      const blob = await fileResponse.blob();
      const blobUrl = URL.createObjectURL(blob);
      downloadFileByUrl([blobUrl], fileName);
    }
  }, []);

  return { handleDownload };
};

export default useDownloadFileById;
